import { Outlet } from 'react-router-dom';
import SettingsLayout from '@/app/(dashboard)/settings/layout';
export function SettingsLayoutWrapper() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
